(function () {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initSaPantry(root) {
    if (root.dataset.fwSaPantryBound === "true") return;
    root.dataset.fwSaPantryBound = "true";

    const buttons = Array.from(root.querySelectorAll("[data-fw-sa-pantry-item]"));
    const cards = Array.from(root.querySelectorAll("[data-fw-sa-pantry-panel]"));
    if (!buttons.length || !cards.length) return;

    let activeId = null;

    const activate = (id) => {
      if (id === activeId) return;
      activeId = id;

      buttons.forEach((btn) => {
        const on = btn.getAttribute("data-fw-sa-pantry-item") === id;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-selected", on ? "true" : "false");
      });

      cards.forEach((card) => {
        const on = card.getAttribute("data-fw-sa-pantry-panel") === id;
        card.classList.toggle("is-active", on);
        card.setAttribute("aria-hidden", on ? "false" : "true");
      });
    };

    buttons.forEach((btn) => {
      const id = btn.getAttribute("data-fw-sa-pantry-item");
      btn.addEventListener("pointerenter", () => activate(id));
      btn.addEventListener("focus", () => activate(id));
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        activate(id);
      });
    });

    const first = buttons[0]?.getAttribute("data-fw-sa-pantry-item");
    if (first) activate(first);
  }

  const boot = () => {
    document.querySelectorAll("[data-fw-sa-pantry]").forEach(initSaPantry);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target;
    if (!(section instanceof Element)) return;
    section.querySelectorAll("[data-fw-sa-pantry]").forEach((root) => {
      root.dataset.fwSaPantryBound = "";
      initSaPantry(root);
    });
  });
})();
